<button class="no-style-button" type="button" aria-label="Close" i18n-aria-label (click)="closeClicked.emit()">
  <img class="close-button" [src]="'assets/icons/grey/X.svg'" alt="" />
</button>
